/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuggestionApproveResponse } from '../models/SuggestionApproveResponse';
import type { SuggestionListResponse } from '../models/SuggestionListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SuggestionsService {
  /**
   * List pending AI suggestions
   * List every pending AI suggestion the user can approve.
   *
   * Per functional spec § "List pending suggestions": each suggestion's
   * ``description`` is plain-language text rendered verbatim by the UI.
   * The router itself does no further parsing — it only shapes the
   * response envelope.
   * @returns SuggestionListResponse Successful Response
   * @throws ApiError
   */
  public static listSuggestionsSuggestionsGet(): CancelablePromise<SuggestionListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/suggestions',
      errors: {
        401: `Unauthorized`,
        402: `Payment Required`,
        403: `Forbidden`,
        404: `Not Found`,
        429: `Too Many Requests`,
        503: `Service Unavailable`,
      },
    });
  }
  /**
   * Approve a suggestion (materializes as a routine)
   * Approve a pending suggestion and create the corresponding routine.
   *
   * Per functional spec § "Approve / dismiss a suggestion": returns
   * ``201 Created`` with the freshly created routine's ID. The new
   * routine is immediately visible from ``GET /routines``.
   *
   * Failure paths:
   * * ``404`` if the suggestion does not exist (or was already
   * approved/dismissed).
   * * ``502`` if HA rejects the automation-create call.
   * * ``503`` if the HA circuit breaker is open.
   * @returns SuggestionApproveResponse Successful Response
   * @throws ApiError
   */
  public static approveSuggestionSuggestionsSuggestionIdApprovePost({
    suggestionId,
  }: {
    suggestionId: string,
  }): CancelablePromise<SuggestionApproveResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/suggestions/{suggestion_id}/approve',
      path: {
        'suggestion_id': suggestionId,
      },
      errors: {
        401: `Unauthorized`,
        402: `Payment Required`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Validation Error`,
        429: `Too Many Requests`,
        502: `Bad Gateway`,
        503: `Service Unavailable`,
      },
    });
  }
  /**
   * Dismiss a suggestion
   * Dismiss a pending suggestion without creating a routine.
   *
   * Per functional spec § "Approve / dismiss a suggestion": returns
   * ``204 No Content``. The suggestion is removed from the pending
   * list; the AI Engine learns from the dismissal and will not
   * resurface the same proposal verbatim.
   * @returns void
   * @throws ApiError
   */
  public static dismissSuggestionSuggestionsSuggestionIdDismissPost({
    suggestionId,
  }: {
    suggestionId: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/suggestions/{suggestion_id}/dismiss',
      path: {
        'suggestion_id': suggestionId,
      },
      errors: {
        401: `Unauthorized`,
        402: `Payment Required`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Validation Error`,
        429: `Too Many Requests`,
        503: `Service Unavailable`,
      },
    });
  }
}
